<script setup>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { library } from "@fortawesome/fontawesome-svg-core"

// Import solid icons
import {
  faAngleDown,
  faAngleRight,
  faAngleUp,
  faArrowLeft,
  faArrowRight,
  faBell,
  faBook,
  faCalendar,
  faCheck,
  faCircleXmark,
  faCloudDownload,
  faCloudUpload,
  faCog,
  faEllipsis,
  faExclamationCircle,
  faEye,
  faEyeSlash,
  faHome,
  faInbox,
  faInfoCircle,
  faMinus,
  faPencil,
  faPlus,
  faSave,
  faSearch,
  faSparkles,
  faMessageBot,
  faTag,
  faTimes,
  faTrash,
  faUser,
  faPaperPlane,
  faMessagePen,
  faPlay,
  faPeopleGroup,
  faCalendarDays,
  faMoneyCheckPen,
  faGavel,
  faClockRotateLeft,
  faWrench,
  faFileContract,
  faCalendarRange,
  faBarsProgress,
  faChartMixed,
  faChartNetwork,
  faMessagesQuestion,
  faBold,
  faItalic,
  faStrikethrough,
  faListUl,
  faListOl,
  faLink,
  faLinkSlash,
  faListDropdown,
} from "fontawesome-icons/solid"

// Import regular icons
import {
  faBars as farBars,
  faBarsStaggered as farBarsStaggered,
  faBell as farBell,
  faBook as farBook,
  faBoxArchive as farBoxArchive,
  faCalendar as farCalendar,
  faCheckCircle as farCheckCircle,
  faClock as farClock,
  faEllipsis as farEllipsis,
  faEllipsisVertical as farEllipsisVertical,
  faGift as farGift,
  faInbox as farInbox,
  faOctagonExclamation as farOctagonExclamation,
  faPaperclip as farPaperclip,
  faPlus as farPlus,
  faTrashCan as farTrashCan,
  faUser as farUser,
  faWrench as farWrench,
  faGear as farGear,
} from "fontawesome-icons/regular"

// Import light icons (requires Pro license)
import {
  faBook as falBook,
  faCog as falCog,
  faHome as falHome,
  faInbox as falInbox,
  faUser as falUser,
} from "fontawesome-icons/light"

library.add(
  // Solid icons
  faHome,
  faUser,
  faCog,
  faBell,
  faCheck,
  faTimes,
  faArrowRight,
  faArrowLeft,
  faPlus,
  faMinus,
  faSave,
  faTrash,
  faPencil,
  faSearch,
  faEye,
  faEyeSlash,
  faAngleDown,
  faAngleRight,
  faAngleUp,
  faExclamationCircle,
  faInfoCircle,
  faCloudUpload,
  faCloudDownload,
  faCalendar,
  faTag,
  faInbox,
  faBook,
  faCircleXmark,
  faEllipsis,
  faSparkles,
  faMessageBot,
  faPaperPlane,
  faMessagePen,
  faPlay,
  faPeopleGroup,
  faCalendarDays,
  faMoneyCheckPen,
  faGavel,
  faClockRotateLeft,
  faWrench,
  faFileContract,
  faCalendarRange,
  faBarsProgress,
  faChartMixed,
  faChartNetwork,
  faMessagesQuestion,
  faBold,
  faItalic,
  faStrikethrough,
  faListUl,
  faListOl,
  faLink,
  faLinkSlash,
  faListDropdown,

  // Regular icons
  farBars,
  farBarsStaggered,
  farCalendar,
  farBell,
  farUser,
  farCheckCircle,
  farClock,
  farBoxArchive,
  farInbox,
  farBook,
  farOctagonExclamation,
  farTrashCan,
  farWrench,
  farEllipsis,
  farEllipsisVertical,
  farPaperclip,
  farPlus,
  farTrashCan,
  farGift,
  farGear,

  // Light icons
  falHome,
  falUser,
  falCog,
  falInbox,
  falBook,
)

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  variant: {
    type: String,
    default: "solid",
    validator: (value) => ["solid", "regular", "light"].includes(value),
  },
  size: {
    type: String,
    default: undefined,
  },
  class: {
    type: String,
    default: "",
  },
})

const prefixMap = {
  light: "fal",
  regular: "far",
  solid: "fas",
}

const prefix = prefixMap[props.variant]
</script>

<template>
  <FontAwesomeIcon :icon="[prefix, icon]" :class="props.class" :size="size" />
</template>
